export enum EMovementType {
  IN = 1,
  OUT,
  TRANSFER,
  ADJUSTMENT,
  WASTE,
  DELETE,
  CLEAR,
}
